import { Outlet } from 'react-router-dom';
import { Container } from '@melio/penny';

export const AuthLayout = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};
